import { clsx } from 'clsx';

import { CustomButton } from './PrimaryButton.style';
import { IPrimaryButton } from './types';

const PrimaryButton: React.FC<React.PropsWithChildren<IPrimaryButton>> = ({
  isDark,
  label,
  className,
  type,
  ...rest
}) => {
  return (
    <CustomButton
      className={clsx(
        'w-full sm:w-200 sm:m-auto font-poppins font-semibold text-16 rounded-10 py-16',
        className,
      )}
      isDark={isDark}
      type={type || 'button'}
      {...rest}
    >
      {label}
    </CustomButton>
  );
};

export default PrimaryButton;
